export default __webpack_public_path__ + "locales/az/ChangeEmailDialog.json?hash=f50b68ac8f7aacc2b930176941f13a7c";